// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ============================================================
 * CONTAINER
 * ============================================================
 */

.graph-container {
    position: relative;

    width: 100%;
    height: 100%;

    overflow: hidden;

    background: transparent;

    box-sizing: border-box;
}


/*
 * Zone avec les scrollbars.
 */

.graph-scroll {
    position: relative;

    width: 100%;
    height: 100%;

    overflow-x: auto;
    overflow-y: auto;

    background: transparent;

    box-sizing: border-box;
}


/*
 * Surface totale du graphe.
 */

.graph-canvas {
    position: relative;

    background: transparent;

    box-sizing: border-box;
}


/*
 * ============================================================
 * SVG DES CONNEXIONS
 * ============================================================
 */

.graph-connections {
    position: absolute;

    left: 0;
    top: 0;

    z-index: 1;

    overflow: visible;

    pointer-events: none;
}


/*
 * Trait reliant deux cases.
 */

.graph-connection {
    fill: none;

    stroke: #888888;

    stroke-width: 4px;

    stroke-linecap: square;

    stroke-linejoin: miter;
}


/*
 * ============================================================
 * CONTAINER DES CASES
 * ============================================================
 */

.graph-nodes {
    position: absolute;

    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    z-index: 2;

    pointer-events: none;
}


/*
 * ============================================================
 * CASE
 * ============================================================
 */

.graph-node {
    position: absolute;

    min-height: 100px;

    box-sizing: border-box;

    background: #080808;

    border: 2px solid #8799a3;

    border-radius: 5px;

    overflow: hidden;

    color: #ffffff;

    font-family: Arial, Helvetica, sans-serif;

    font-size: 12px;

    pointer-events: auto;

    /*
     * Empêche le contenu de faire varier la largeur.
     */
    max-width: 300px;
}


/*
 * ============================================================
 * BARRE DE TITRE
 * ============================================================
 */

.graph-node-title {
    position: relative;

    width: 100%;

    min-height: 28px;

    box-sizing: border-box;

    display: flex;

    flex-direction: row;

    align-items: center;

    padding: 2px 3px;

    color: #ffffff;

    overflow: hidden;
}


/*
 * Texte du titre.
 */

.graph-node-title-text {
    flex: 1 1;

    min-width: 0;

    padding-left: 4px;
    padding-right: 4px;

    text-align: center;

    font-size: 13px;

    line-height: 20px;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
}


/*
 * ============================================================
 * BOUTONS DU TITRE
 * ============================================================
 */

.graph-node-buttons {
    flex-shrink: 0;

    display: flex;

    flex-direction: row;

    align-items: center;

    justify-content: flex-end;

    height: 22px;
}


/*
 * Bouton individuel.
 */

.graph-title-button {
    width: 18px;
    height: 18px;

    margin: 0 1px;
    padding: 1px;

    filter: invert(1);

    box-sizing: border-box;

    border: none;

    outline: none;

    background: transparent;

    display: flex;

    align-items: center;
    justify-content: center;

    cursor: pointer;

    border-radius: 3px;
}


/*
 * Image du bouton.
 */

.graph-title-button img {
    display: block;

    width: 15px;
    height: 15px;

    object-fit: contain;

    -webkit-user-select: none;

            user-select: none;

    pointer-events: none;
}


/*
 * Hover.
 */

.graph-title-button:hover:not(:disabled) {
    background: rgba(
        255,
        255,
        255,
        0.20
    );
}


/*
 * Clic.
 */

.graph-title-button:active:not(:disabled) {
    background: rgba(
        255,
        255,
        255,
        0.35
    );
}


/*
 * Bouton disabled.
 */

.graph-title-button:disabled {
    opacity: 0.30;

    cursor: default;
}


/*
 * ============================================================
 * CONTENU
 * ============================================================
 */

.graph-node-content {
    width: 100%;

    min-height: 45px;

    padding: 8px 7px;

    box-sizing: border-box;

    background: #080808;
}


/*
 * Ligne de texte.
 */

.graph-node-line {
    width: 100%;

    min-height: 18px;

    line-height: 18px;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
}


/*
 * ============================================================
 * FOOTER
 * ============================================================
 */

.graph-node-footer {
    width: calc(100% - 10px);

    height: 32px;

    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 5px;

    box-sizing: border-box;

    border: 2px solid #8799a3;

    border-radius: 4px;

    background: #050505;

    display: flex;

    align-items: center;

    justify-content: center;

    overflow: hidden;
}


/*
 * ============================================================
 * FOOTER TEXTE
 * ============================================================
 */

.graph-footer-text {
    width: 100%;

    padding: 0 5px;

    box-sizing: border-box;

    text-align: center;

    font-size: 12px;

    line-height: 20px;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
}


/*
 * ============================================================
 * PROGRESS BAR
 * ============================================================
 */

.graph-progress {
    position: relative;

    width: calc(100% - 6px);

    height: 20px;

    margin-left: 3px;
    margin-right: 3px;

    box-sizing: border-box;

    border: 1px solid #555555;

    border-radius: 3px;

    background: #202020;

    overflow: hidden;
}


/*
 * Partie remplie.
 */

.graph-progress-value {
    position: absolute;

    left: 0;
    top: 0;
    bottom: 0;

    min-width: 0;

    transition:
        width 0.2s ease;

    z-index: 1;
}


/*
 * Pourcentage affiché au-dessus.
 */

.graph-progress-text {
    position: absolute;

    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    display: flex;

    align-items: center;
    justify-content: center;

    color: #ffffff;

    font-size: 11px;

    z-index: 2;

    pointer-events: none;

    -webkit-user-select: none;

            user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/applications/dialogs/addvideo/graphvideo/graphenode.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,gBAAgB;;IAEhB,uBAAuB;;IAEvB,sBAAsB;AAC1B;;;AAGA;;EAEE;;AAEF;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,gBAAgB;IAChB,gBAAgB;;IAEhB,uBAAuB;;IAEvB,sBAAsB;AAC1B;;;AAGA;;EAEE;;AAEF;IACI,kBAAkB;;IAElB,uBAAuB;;IAEvB,sBAAsB;AAC1B;;;AAGA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,OAAO;IACP,MAAM;;IAEN,UAAU;;IAEV,iBAAiB;;IAEjB,oBAAoB;AACxB;;;AAGA;;EAEE;;AAEF;IACI,UAAU;;IAEV,eAAe;;IAEf,iBAAiB;;IAEjB,sBAAsB;;IAEtB,sBAAsB;AAC1B;;;AAGA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,OAAO;IACP,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,UAAU;;IAEV,oBAAoB;AACxB;;;AAGA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,iBAAiB;;IAEjB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,yBAAyB;;IAEzB,kBAAkB;;IAElB,gBAAgB;;IAEhB,cAAc;;IAEd,yCAAyC;;IAEzC,eAAe;;IAEf,oBAAoB;;IAEpB;;MAEE;IACF,gBAAgB;AACpB;;;AAGA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,WAAW;;IAEX,gBAAgB;;IAEhB,sBAAsB;;IAEtB,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,cAAc;;IAEd,gBAAgB;AACpB;;;AAGA;;EAEE;;AAEF;IACI,SAAO;;IAEP,YAAY;;IAEZ,iBAAiB;IACjB,kBAAkB;;IAElB,kBAAkB;;IAElB,eAAe;;IAEf,iBAAiB;;IAEjB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;AAGA;;;;EAIE;;AAEF;IACI,cAAc;;IAEd,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,yBAAyB;;IAEzB,YAAY;AAChB;;;AAGA;;EAEE;;AAEF;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,YAAY;;IAEZ,iBAAiB;;IAEjB,sBAAsB;;IAEtB,YAAY;;IAEZ,aAAa;;IAEb,uBAAuB;;IAEvB,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;;IAEf,kBAAkB;AACtB;;;AAGA;;EAEE;;AAEF;IACI,cAAc;;IAEd,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB,yBAAiB;;YAAjB,iBAAiB;;IAEjB,oBAAoB;AACxB;;;AAGA;;EAEE;;AAEF;IACI;;;;;KAKC;AACL;;;AAGA;;EAEE;;AAEF;IACI;;;;;KAKC;AACL;;;AAGA;;EAEE;;AAEF;IACI,aAAa;;IAEb,eAAe;AACnB;;;AAGA;;;;EAIE;;AAEF;IACI,WAAW;;IAEX,gBAAgB;;IAEhB,gBAAgB;;IAEhB,sBAAsB;;IAEtB,mBAAmB;AACvB;;;AAGA;;EAEE;;AAEF;IACI,WAAW;;IAEX,gBAAgB;;IAEhB,iBAAiB;;IAEjB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;AAGA;;;;EAIE;;AAEF;IACI,wBAAwB;;IAExB,YAAY;;IAEZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,sBAAsB;;IAEtB,yBAAyB;;IAEzB,kBAAkB;;IAElB,mBAAmB;;IAEnB,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,gBAAgB;AACpB;;;AAGA;;;;EAIE;;AAEF;IACI,WAAW;;IAEX,cAAc;;IAEd,sBAAsB;;IAEtB,kBAAkB;;IAElB,eAAe;;IAEf,iBAAiB;;IAEjB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;AAGA;;;;EAIE;;AAEF;IACI,kBAAkB;;IAElB,uBAAuB;;IAEvB,YAAY;;IAEZ,gBAAgB;IAChB,iBAAiB;;IAEjB,sBAAsB;;IAEtB,yBAAyB;;IAEzB,kBAAkB;;IAElB,mBAAmB;;IAEnB,gBAAgB;AACpB;;;AAGA;;EAEE;;AAEF;IACI,kBAAkB;;IAElB,OAAO;IACP,MAAM;IACN,SAAS;;IAET,YAAY;;IAEZ;uBACmB;;IAEnB,UAAU;AACd;;;AAGA;;EAEE;;AAEF;IACI,kBAAkB;;IAElB,OAAO;IACP,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;;IAEf,UAAU;;IAEV,oBAAoB;;IAEpB,yBAAiB;;YAAjB,iBAAiB;AACrB","sourcesContent":["/*\n * ============================================================\n * CONTAINER\n * ============================================================\n */\n\n.graph-container {\n    position: relative;\n\n    width: 100%;\n    height: 100%;\n\n    overflow: hidden;\n\n    background: transparent;\n\n    box-sizing: border-box;\n}\n\n\n/*\n * Zone avec les scrollbars.\n */\n\n.graph-scroll {\n    position: relative;\n\n    width: 100%;\n    height: 100%;\n\n    overflow-x: auto;\n    overflow-y: auto;\n\n    background: transparent;\n\n    box-sizing: border-box;\n}\n\n\n/*\n * Surface totale du graphe.\n */\n\n.graph-canvas {\n    position: relative;\n\n    background: transparent;\n\n    box-sizing: border-box;\n}\n\n\n/*\n * ============================================================\n * SVG DES CONNEXIONS\n * ============================================================\n */\n\n.graph-connections {\n    position: absolute;\n\n    left: 0;\n    top: 0;\n\n    z-index: 1;\n\n    overflow: visible;\n\n    pointer-events: none;\n}\n\n\n/*\n * Trait reliant deux cases.\n */\n\n.graph-connection {\n    fill: none;\n\n    stroke: #888888;\n\n    stroke-width: 4px;\n\n    stroke-linecap: square;\n\n    stroke-linejoin: miter;\n}\n\n\n/*\n * ============================================================\n * CONTAINER DES CASES\n * ============================================================\n */\n\n.graph-nodes {\n    position: absolute;\n\n    left: 0;\n    top: 0;\n\n    width: 100%;\n    height: 100%;\n\n    z-index: 2;\n\n    pointer-events: none;\n}\n\n\n/*\n * ============================================================\n * CASE\n * ============================================================\n */\n\n.graph-node {\n    position: absolute;\n\n    min-height: 100px;\n\n    box-sizing: border-box;\n\n    background: #080808;\n\n    border: 2px solid #8799a3;\n\n    border-radius: 5px;\n\n    overflow: hidden;\n\n    color: #ffffff;\n\n    font-family: Arial, Helvetica, sans-serif;\n\n    font-size: 12px;\n\n    pointer-events: auto;\n\n    /*\n     * Empêche le contenu de faire varier la largeur.\n     */\n    max-width: 300px;\n}\n\n\n/*\n * ============================================================\n * BARRE DE TITRE\n * ============================================================\n */\n\n.graph-node-title {\n    position: relative;\n\n    width: 100%;\n\n    min-height: 28px;\n\n    box-sizing: border-box;\n\n    display: flex;\n\n    flex-direction: row;\n\n    align-items: center;\n\n    padding: 2px 3px;\n\n    color: #ffffff;\n\n    overflow: hidden;\n}\n\n\n/*\n * Texte du titre.\n */\n\n.graph-node-title-text {\n    flex: 1;\n\n    min-width: 0;\n\n    padding-left: 4px;\n    padding-right: 4px;\n\n    text-align: center;\n\n    font-size: 13px;\n\n    line-height: 20px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n}\n\n\n/*\n * ============================================================\n * BOUTONS DU TITRE\n * ============================================================\n */\n\n.graph-node-buttons {\n    flex-shrink: 0;\n\n    display: flex;\n\n    flex-direction: row;\n\n    align-items: center;\n\n    justify-content: flex-end;\n\n    height: 22px;\n}\n\n\n/*\n * Bouton individuel.\n */\n\n.graph-title-button {\n    width: 18px;\n    height: 18px;\n\n    margin: 0 1px;\n    padding: 1px;\n\n    filter: invert(1);\n\n    box-sizing: border-box;\n\n    border: none;\n\n    outline: none;\n\n    background: transparent;\n\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n\n    cursor: pointer;\n\n    border-radius: 3px;\n}\n\n\n/*\n * Image du bouton.\n */\n\n.graph-title-button img {\n    display: block;\n\n    width: 15px;\n    height: 15px;\n\n    object-fit: contain;\n\n    user-select: none;\n\n    pointer-events: none;\n}\n\n\n/*\n * Hover.\n */\n\n.graph-title-button:hover:not(:disabled) {\n    background: rgba(\n        255,\n        255,\n        255,\n        0.20\n    );\n}\n\n\n/*\n * Clic.\n */\n\n.graph-title-button:active:not(:disabled) {\n    background: rgba(\n        255,\n        255,\n        255,\n        0.35\n    );\n}\n\n\n/*\n * Bouton disabled.\n */\n\n.graph-title-button:disabled {\n    opacity: 0.30;\n\n    cursor: default;\n}\n\n\n/*\n * ============================================================\n * CONTENU\n * ============================================================\n */\n\n.graph-node-content {\n    width: 100%;\n\n    min-height: 45px;\n\n    padding: 8px 7px;\n\n    box-sizing: border-box;\n\n    background: #080808;\n}\n\n\n/*\n * Ligne de texte.\n */\n\n.graph-node-line {\n    width: 100%;\n\n    min-height: 18px;\n\n    line-height: 18px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n}\n\n\n/*\n * ============================================================\n * FOOTER\n * ============================================================\n */\n\n.graph-node-footer {\n    width: calc(100% - 10px);\n\n    height: 32px;\n\n    margin-left: 5px;\n    margin-right: 5px;\n    margin-bottom: 5px;\n\n    box-sizing: border-box;\n\n    border: 2px solid #8799a3;\n\n    border-radius: 4px;\n\n    background: #050505;\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    overflow: hidden;\n}\n\n\n/*\n * ============================================================\n * FOOTER TEXTE\n * ============================================================\n */\n\n.graph-footer-text {\n    width: 100%;\n\n    padding: 0 5px;\n\n    box-sizing: border-box;\n\n    text-align: center;\n\n    font-size: 12px;\n\n    line-height: 20px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n}\n\n\n/*\n * ============================================================\n * PROGRESS BAR\n * ============================================================\n */\n\n.graph-progress {\n    position: relative;\n\n    width: calc(100% - 6px);\n\n    height: 20px;\n\n    margin-left: 3px;\n    margin-right: 3px;\n\n    box-sizing: border-box;\n\n    border: 1px solid #555555;\n\n    border-radius: 3px;\n\n    background: #202020;\n\n    overflow: hidden;\n}\n\n\n/*\n * Partie remplie.\n */\n\n.graph-progress-value {\n    position: absolute;\n\n    left: 0;\n    top: 0;\n    bottom: 0;\n\n    min-width: 0;\n\n    transition:\n        width 0.2s ease;\n\n    z-index: 1;\n}\n\n\n/*\n * Pourcentage affiché au-dessus.\n */\n\n.graph-progress-text {\n    position: absolute;\n\n    left: 0;\n    top: 0;\n\n    width: 100%;\n    height: 100%;\n\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n\n    color: #ffffff;\n\n    font-size: 11px;\n\n    z-index: 2;\n\n    pointer-events: none;\n\n    user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
